import ReactDOM from 'react-dom'

export const triggerModal = (modal, idModal) => {
  var div = document.createElement('div')
  div.id = idModal
  document.querySelector('#root').appendChild(div)
  ReactDOM.render(modal, div)
}
export const closeModal = (idModal) => {
  let elem = document.getElementById(idModal)
  elem.remove()
}
